import { C as CommonGAssets } from './index-d943196d.js';

var HEALTH_TOOL_NAME;
(function (HEALTH_TOOL_NAME) {
    HEALTH_TOOL_NAME["DUE_DATE"] = "due-date-calculator";
    HEALTH_TOOL_NAME["BMI"] = "bmi";
    HEALTH_TOOL_NAME["BMR"] = "bmr";
    HEALTH_TOOL_NAME["OVULATION"] = "ovulation";
    HEALTH_TOOL_NAME["IFRAME"] = "IFRAME";
    HEALTH_TOOL_NAME["PWG"] = "pregnancy-weight-gain";
    HEALTH_TOOL_NAME["THR"] = "heart-rate";
    HEALTH_TOOL_NAME["BABY_VACCINE"] = "vaccination-tool";
    HEALTH_TOOL_NAME["BABY_GROWTH"] = "baby-growth-tracking";
    HEALTH_TOOL_NAME["BABY_POOP"] = "baby-poop-checking";
})(HEALTH_TOOL_NAME || (HEALTH_TOOL_NAME = {}));
var HEALTH_TOOL_NAME_TRACKING;
(function (HEALTH_TOOL_NAME_TRACKING) {
    HEALTH_TOOL_NAME_TRACKING["DUE_DATE"] = "DueDate";
    HEALTH_TOOL_NAME_TRACKING["BMI"] = "BMI";
    HEALTH_TOOL_NAME_TRACKING["BMR"] = "BMR";
    HEALTH_TOOL_NAME_TRACKING["OVULATION"] = "Ovulation";
    HEALTH_TOOL_NAME_TRACKING["PWG"] = "PregnancyWeightGain";
    HEALTH_TOOL_NAME_TRACKING["THR"] = "TargetHeartRate";
    HEALTH_TOOL_NAME_TRACKING["BABY_VACCINE"] = "BabyVaccine";
    HEALTH_TOOL_NAME_TRACKING["BABY_GROWTH"] = "BabyGrowth";
    HEALTH_TOOL_NAME_TRACKING["BABY_POOP"] = "BabyPoopChecking";
})(HEALTH_TOOL_NAME_TRACKING || (HEALTH_TOOL_NAME_TRACKING = {}));
const HEALTH_TOOL_TYPE = {
    DUE_DATE: HEALTH_TOOL_NAME.DUE_DATE,
    BMI: HEALTH_TOOL_NAME.BMI,
    BMR: HEALTH_TOOL_NAME.BMR,
    OVULATION: HEALTH_TOOL_NAME.OVULATION,
    IFRAME: HEALTH_TOOL_NAME.IFRAME,
    PWG: HEALTH_TOOL_NAME.PWG,
    THR: HEALTH_TOOL_NAME.THR,
    BABY_VACCINE: HEALTH_TOOL_NAME.BABY_VACCINE,
    BABY_GROWTH: HEALTH_TOOL_NAME.BABY_GROWTH,
    BABY_POOP: HEALTH_TOOL_NAME.BABY_POOP,
};
const HEALTH_TOOL_DEFAULT_IMG = {
    [HEALTH_TOOL_TYPE.DUE_DATE]: CommonGAssets.getAssetPath('health-tools/due-date-icon.svg'),
};

export { HEALTH_TOOL_TYPE as H, HEALTH_TOOL_DEFAULT_IMG as a, HEALTH_TOOL_NAME_TRACKING as b };
